<template>
  <el-collapse v-model="activeNames" style="border-radius: 10px;">
    <el-collapse-item name="1">
      <template slot="title">
        <div style="font-size: 16px; font-weight: 600;width:100%">付款資訊</div>
      </template>
      <div style="padding: 20px;padding-bottom: 0px; font-size:16px;">
        <div style="line-height:2.6;">
          <el-row>
            <el-col :span="7" style="color:#6C6B6B;">
              付款資訊
            </el-col>
            <el-col :span="14">
              <span style="color:#000000;">{{ info.method }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7" style="color:#6C6B6B;">
              付款狀態
            </el-col>
            <el-col :span="14">
              <span style="color:#000000;">{{ info.status || '-' }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="7" style="color:#6C6B6B;">
              付款時間
            </el-col>
            <el-col :span="14">
              <span style="color:#000000;">{{ info.time }}</span>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'PaymentInfoPartial',
  components: {},
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 控制預設是否展開 ['1'] 展開， [] 收合'
      activeNames: ['1'],
    }
  },
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
  background-color: #e5e7eb;
  border-radius: 10px;
}

::v-deep .el-collapse-item__header.is-active {
  border-radius: 10px 10px 0 0;
}

::v-deep .el-collapse-item__arrow {
  font-size: 26px;
  font-weight: 900;
}

::v-deep .el-divider--vertical {
  height: 2.2em;
  background-color: #e5e7eb;
  margin-top: 10px;
}
</style>
